import { createSlice } from "@reduxjs/toolkit";
const initialState = {};
const messageSlice = createSlice({
  name: "message",
  initialState,
  reducers: {
    setMessage: (state, action) => {
      console.log("messageslice", action.payload);
      return { message: action.payload };
    },
    clearMessage: () => {
      return { message: "" };
    },
  },
});

export default messageSlice;
